import React from 'react';
import { useTranslation } from 'react-i18next';
import './FilterSidebar.css';

const nepaleseProvinces = [
  'Province 1'
];

const districts = {
  'Province 1': ['Morang', 'Sunsari', 'Jhapa']
};

const FilterSidebar = ({
  selectedCategory,
  setSelectedCategory,
  priceRange,
  setPriceRange,
  selectedProvince,
  setSelectedProvince,
  selectedDistrict,
  setSelectedDistrict,
  organicOnly,
  setOrganicOnly,
  minRating,
  setMinRating,
  resetFilters
}) => {
  const { t } = useTranslation();

  const categories = [
    { value: 'all', label: t('filter.allCategories') },
    { value: 'vegetables', label: t('filter.vegetables') },
    { value: 'fruits', label: t('filter.fruits') },
    { value: 'grains', label: t('filter.grains') },
    { value: 'dairy', label: t('filter.dairy') },
    { value: 'spices', label: t('filter.spices') },
    { value: 'other', label: t('filter.other') },
  ];

  const ratingOptions = [
    { value: 0, label: t('filter.allRatings') },
    { value: 4, label: t('filter.fourUp') },
    { value: 3, label: t('filter.threeUp') },
    { value: 0, label: t('filter.topRated') },
  ];

  return (
    <div className="filter-sidebar">
      <h3 className="sidebar-title">{t('filter.title')}</h3>

      {/* Category Filter */}
      <div className="filter-section">
        <h4 className="filter-section-title">
          {t('filter.category')}
        </h4>
        <div className="category-list">
          {categories.map((category) => (
            <label key={category.value} className="category-checkbox">
              <input
                type="radio"
                name="category"
                value={category.value}
                checked={selectedCategory === category.value}
                onChange={(e) => setSelectedCategory(e.target.value)}
              />
              <span className="checkmark-radio"></span>
              <span className="category-label">{category.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Price Range Slider */}
      <div className="filter-section">
        <h4 className="filter-section-title">
          {t('filter.priceRange')}
        </h4>
        <div className="price-range">
          <div className="price-display">
            Rs. {priceRange[0]} – Rs. {priceRange[1]}
          </div>
          <input
            type="range"
            min="0"
            max="1000"
            value={priceRange[0]}
            onChange={(e) => setPriceRange([parseInt(e.target.value), priceRange[1]])}
            className="price-slider"
          />
          <input
            type="range"
            min="0"
            max="1000"
            value={priceRange[1]}
            onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
            className="price-slider"
          />
        </div>
      </div>

      {/* Location Filter */}
      <div className="filter-section">
        <h4 className="filter-section-title">
          {t('filter.location')}
        </h4>
        <select
          className="location-select"
          value={selectedProvince}
          onChange={(e) => {
            setSelectedProvince(e.target.value);
            setSelectedDistrict('');
          }}
        >
          <option value="">{t('filter.selectProvince')}</option>
          {nepaleseProvinces.map(province => (
            <option key={province} value={province}>{province}</option>
          ))}
        </select>
        <select
          className="location-select"
          value={selectedDistrict}
          onChange={(e) => setSelectedDistrict(e.target.value)}
          disabled={!selectedProvince}
        >
          <option value="">{t('filter.selectDistrict')}</option>
          {selectedProvince && districts[selectedProvince]?.map(district => (
            <option key={district} value={district}>{district}</option>
          ))}
        </select>
      </div>

      {/* Organic Filter */}
      <div className="filter-section">
        <h4 className="filter-section-title">
          {t('filter.organic')}
        </h4>
        <label className="organic-switch">
          <input
            type="checkbox"
            checked={organicOnly}
            onChange={(e) => setOrganicOnly(e.target.checked)}
          />
          <span className="switch-slider"></span>
          <span className="switch-label">{t('filter.organicOnly')}</span>
        </label>
      </div>

      {/* Rating Filter */}
      <div className="filter-section">
        <h4 className="filter-section-title">
          {t('filter.rating')}
        </h4>
        <div className="rating-list">
          {ratingOptions.map((option, index) => (
            <label key={index} className="rating-checkbox">
              <input
                type="radio"
                name="rating"
                value={option.value}
                checked={minRating === option.value}
                onChange={(e) => setMinRating(parseInt(e.target.value))}
              />
              <span className="checkmark-radio"></span>
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Reset Button */}
      <button className="reset-filters-btn-sidebar" onClick={resetFilters}>
        {t('filter.resetAll')}
      </button>
    </div>
  );
};

export default FilterSidebar;
